export const nav_carbon = "Carbon";
export const nav_builds = "Builds";
export const nav_atelier = "Atelier";
export const nav_models = "Modèles";
export const nav_process = "Processus";
export const nav_contact = "Contact";
export const nav_about = "À Propos";
export const nav_cta = "Démarrez Votre Build";

export const hero_tagline = "Fabriqué en Carbone. Construit Sans Compromis.";
export const hero_cta_primary = "Configurez le Vôtre";
export const hero_cta_secondary = "Explorer les Modèles";
export const hero_scroll = "Faites Défiler pour Découvrir";
export const hero_video_toggle = "Vidéo";
export const hero_slides_toggle = "Diapositives";
export const hero_mute = "Muet";
export const hero_unmute = "Son Activé";

export const manifest_title = "Le Manifeste Veragua";
export const manifest_text = "Nous concevons au-delà des conventions. Chaque composant est scruté, chaque surface raffinée. La fibre de carbone n'est pas un choix de matériau—c'est notre fondation. La performance n'est pas une fonctionnalité—c'est notre obsession. Nous ne suivons pas les tendances. Nous établissons des standards.";
export const manifest_line1 = "Ce n'est pas du style.";
export const manifest_line2 = "C'est une reconstruction.";
export const manifest_line3 = "Scanné en 3D. Conçu. Fini à la main.";

export const carbon_title = "Division Carbon";
export const carbon_subtitle = "Excellence en Ingénierie";
export const carbon_desc = "Notre Division Carbon représente le summum de l'ingénierie légère. Chaque composant est méticuleusement fabriqué en fibre de carbone de qualité aérospatiale, réduisant le poids tout en maximisant l'intégrité structurelle et les performances.";
export const carbon_cta = "Explorer la Technologie Carbon";
export const carbon_division_label = "DIVISION 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Chaque composant est développé de la matière composite brute à la pièce finie en interne. Pas de sous-traitance. Pas de compromis.";
export const carbon_custom_config = "Configurations personnalisées disponibles pour toutes les plateformes.";
export const carbon_request_build = "DEMANDER UN BUILD PERSONNALISÉ";
export const carbon_view_details = "VOIR LES DÉTAILS";
export const carbon_materials_label = "MATÉRIAUX";
export const carbon_process_label = "PROCESSUS";

export const builds_title = "Builds Signature";
export const builds_subtitle = "Chefs-d'Œuvre en Mouvement";
export const builds_view = "Voir le Build";
export const builds_limited_series = "Série Limitée";
export const builds_each_build = "Chaque build est une déclaration unique. Conçu à la perfection. Limité à dix.";
export const builds_view_project = "VOIR LE PROJET";

export const engineering_title = "Détails d'Ingénierie";
export const engineering_subtitle = "Précision dans Chaque Composant";
export const engineering_tab_chassis = "Châssis";
export const engineering_tab_aero = "Aérodynamique";
export const engineering_tab_power = "Groupe Motopropulseur";
export const engineering_chassis_title = "Châssis Monocoque en Carbone";
export const engineering_chassis_desc = "Notre châssis monocoque en fibre de carbone propriétaire offre une rigidité exceptionnelle tout en maintenant un poids minimal. Chaque couche est précisément conçue pour un rapport résistance-poids optimal.";
export const engineering_aero_title = "Aérodynamique Active";
export const engineering_aero_desc = "Les systèmes aérodynamiques intelligents s'adaptent en temps réel, optimisant l'appui et la traînée pour chaque condition de conduite. Testé en soufflerie, éprouvé sur piste.";
export const engineering_power_title = "Groupe Motopropulseur Hybride";
export const engineering_power_desc = "La technologie hybride avancée combine puissance brute et efficacité. Les moteurs électriques fournissent un couple instantané tandis que le moteur à combustion offre des performances soutenues.";
export const engineering_technical_spec = "Spécification Technique";
export const engineering_headline1 = "Conçu aux";
export const engineering_headline2 = "tolérances exactes.";
export const engineering_body = "Chaque chiffre ci-dessous est mesuré, pas estimé. Notre processus est basé sur une méthodologie de qualité aérospatiale appliquée à la construction automobile en carbone.";
export const engineering_process_overview = "Aperçu du Processus";
export const engineering_docs_note = "Documentation technique complète disponible sur demande de projet";
export const engineering_request_docs = "Demander la Documentation";

export const atelier_title = "Atelier d'Intérieur";
export const atelier_subtitle = "Artisanat Sur Mesure";
export const atelier_desc = "Notre Atelier d'Intérieur transforme les habitacles en sanctuaires personnalisés. Chaque couture, chaque surface, chaque détail est adapté à votre vision. Des cuirs sélectionnés à la main aux tissages de carbone personnalisés, nous créons des intérieurs qui reflètent votre individualité.";
export const atelier_cta = "Concevez Votre Intérieur";
export const atelier_craftsmanship_label = "Artisanat";
export const atelier_headline = "INTÉRIEUR / ATELIER";
export const atelier_body = "Là où les matériaux rencontrent la maîtrise. Chaque couture, chaque surface, conçue pour la perfection.";
export const atelier_material_label = "MATÉRIAU";
export const atelier_our_services = "NOS SERVICES";
export const atelier_schedule = "PLANIFIER UNE CONSULTATION";

export const performance_title = "Ligne Performance";
export const performance_subtitle = "Puissance Sans Compromis";
export const performance_spec_power = "Puissance de Sortie";
export const performance_spec_torque = "Couple Maximal";
export const performance_spec_weight = "Poids à Vide";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Vitesse Maximale";
export const performance_cta = "Voir les Spécifications";
export const performance_label = "Performance";
export const performance_headline1 = "DYNAMIQUE";
export const performance_headline2 = "CONÇUE";

export const models_title = "Galerie de Modèles";
export const models_subtitle = "Explorez Notre Collection";
export const models_search_placeholder = "Rechercher des modèles...";
export const models_filter_all = "Tous les Modèles";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Édition Limitée";
export const models_view = "Voir les Détails";
export const models_configure = "Configurer";
export const models_config_label = "Configuration · Modèles";
export const models_headline = "MODÈLES / GALERIE";
export const models_body = "Choisissez votre véhicule de base et configurez-le selon votre vision. Chaque projet est exécuté individuellement.";
export const models_available = "modèles disponibles pour configuration";
export const models_ask_another = "RENSEIGNEZ-VOUS SUR UN AUTRE MODÈLE";
export const models_swipe = "GLISSEZ POUR EXPLORER";

export const process_title = "Processus de Build";
export const process_subtitle = "De la Vision à la Réalité";
export const process_step1_title = "Consultation";
export const process_step1_desc = "Commencez votre voyage avec notre équipe de conception. Nous explorerons votre vision, vos préférences et vos exigences de performance.";
export const process_step2_title = "Configuration";
export const process_step2_desc = "Sélectionnez chaque détail—des motifs de tissage de carbone aux matériaux d'intérieur. Visualisez votre build en temps réel.";
export const process_step3_title = "Ingénierie";
export const process_step3_desc = "Nos ingénieurs optimisent chaque composant selon vos spécifications, garantissant des performances maximales et une fiabilité.";
export const process_step4_title = "Fabrication";
export const process_step4_desc = "Les maîtres artisans donnent vie à votre vision, construisant à la main chaque composant avec précision et soin.";
export const process_step5_title = "Livraison";
export const process_step5_desc = "Vivez le moment où votre chef-d'œuvre arrive. Remise complète et support à vie inclus.";
export const process_label = "Processus de Build";
export const process_headline1 = "Du Carbone Brut";
export const process_headline2 = "à l'Art Fini.";
export const process_body = "Chaque build ORVANTHE suit un processus méticuleux en six étapes. Pas de raccourcis. Pas de sous-traitance. Chaque véhicule est une expression singulière de précision et d'artisanat.";
export const process_start_build = "Démarrez Votre Build";
export const process_hours = "Heures par Build";
export const process_craftsmen = "Maîtres Artisans";
export const process_inspection = "Points d'Inspection";
export const process_warranty = "Garantie Structurelle";

export const contact_title = "Démarrez Votre Build";
export const contact_subtitle = "Créons Quelque Chose d'Extraordinaire";
export const contact_form_name = "Nom Complet";
export const contact_form_email = "Adresse E-mail";
export const contact_form_phone = "Numéro de Téléphone";
export const contact_form_interest = "Je Suis Intéressé Par";
export const contact_form_interest_new = "Nouveau Build";
export const contact_form_interest_custom = "Projet Personnalisé";
export const contact_form_interest_carbon = "Division Carbon";
export const contact_form_interest_atelier = "Atelier d'Intérieur";
export const contact_form_interest_inquiry = "Demande Générale";
export const contact_form_message = "Parlez-Nous de Votre Vision";
export const contact_form_submit = "Envoyer la Demande";
export const contact_form_submitting = "Envoi en Cours...";
export const contact_form_success = "Merci ! Nous vous contacterons dans les 24 heures.";
export const contact_form_error = "Quelque chose s'est mal passé. Veuillez réessayer.";
export const contact_form_required = "Ce champ est obligatoire";
export const contact_form_email_invalid = "Veuillez entrer une adresse e-mail valide";
export const contact_configure_label = "Configurer";
export const contact_headline1 = "DÉMARREZ VOTRE";
export const contact_headline2 = "BUILD";
export const contact_body = "Sélectionnez votre package, choisissez votre véhicule, et nous créerons quelque chose d'irremplaçable.";
export const contact_step_package = "Package";
export const contact_step_vehicle = "Véhicule";
export const contact_step_details = "Détails";
export const contact_continue = "Continuer";
export const contact_back = "Retour";
export const contact_edit = "Modifier";
export const contact_change = "Changer";
export const contact_select_brand = "Sélectionner la Marque *";
export const contact_select_model = "Sélectionner le Modèle *";
export const contact_enter_vehicle = "Entrez Votre Véhicule *";
export const contact_timeline_label = "Délai Préféré";
export const contact_timeline_placeholder = "Sélectionner un délai";
export const contact_timeline_asap = "Dès que possible";
export const contact_timeline_1_3 = "1–3 mois";
export const contact_timeline_3_6 = "3–6 mois";
export const contact_timeline_6_12 = "6–12 mois";
export const contact_timeline_exploring = "Juste explorer les options";
export const contact_additional_details = "Détails Supplémentaires";
export const contact_message_placeholder = "Parlez-nous de votre vision — préférences de couleur, modifications spécifiques, inspiration...";
export const contact_submit_inquiry = "Envoyer la Demande";
export const contact_processing = "Traitement en Cours...";
export const contact_success = "Merci ! Nous vous contacterons dans les 24 heures pour discuter de votre build.";
export const contact_error = "Veuillez remplir tous les champs obligatoires et réessayer.";
export const contact_location = "Varsovie, PL";

export const news_title = "Dernières Nouvelles";
export const news_subtitle = "Actualités de Veragua";
export const news_read_more = "Lire Plus";

export const social_title = "Suivez Notre Voyage";
export const social_subtitle = "Dans les Coulisses";
export const social_view_post = "Voir la Publication";

export const footer_tagline = "Excellence en Ingénierie. Performance Sans Compromis.";
export const footer_company = "Entreprise";
export const footer_company_about = "À Propos";
export const footer_company_careers = "Carrières";
export const footer_company_press = "Presse";
export const footer_company_contact = "Contact";
export const footer_models = "Modèles";
export const footer_models_hypercar = "Série Hypercar";
export const footer_models_gt = "Collection GT";
export const footer_models_roadster = "Ligne Roadster";
export const footer_models_limited = "Éditions Limitées";
export const footer_services = "Services";
export const footer_services_carbon = "Division Carbon";
export const footer_services_atelier = "Atelier d'Intérieur";
export const footer_services_bespoke = "Projets Sur Mesure";
export const footer_services_support = "Support Propriétaire";
export const footer_legal = "Légal";
export const footer_legal_privacy = "Politique de Confidentialité";
export const footer_legal_terms = "Conditions d'Utilisation";
export const footer_legal_cookies = "Politique de Cookies";
export const footer_copyright = "© 2024 Veragua. Tous droits réservés.";
export const footer_powered = "Créateur de Sites Web";
export const footer_copyright_text = "© ORVANTHE 2025. TOUS DROITS RÉSERVÉS.";
export const footer_tagline_short = "Fabriqué en Carbone. Construit Sans Compromis.";

export const about_hero_title = "À Propos de Veragua";
export const about_hero_subtitle = "Concevoir l'Avenir de la Performance";
export const about_story_title = "Notre Histoire";
export const about_story_text = "Fondée sur le principe que le compromis n'a pas sa place dans l'excellence automobile, Veragua est née d'une vision visant à redéfinir ce qui est possible. Nous ne construisons pas des voitures—nous concevons des expériences qui transcendent les frontières conventionnelles.";
export const about_philosophy_title = "Notre Philosophie";
export const about_philosophy_text = "Chaque décision, chaque composant, chaque détail est guidé par un engagement inébranlable envers la perfection. Nous croyons en la pureté du but, l'élégance de l'ingénierie et la poursuite incessante de la performance.";
export const about_craftsmanship_title = "Artisanat";
export const about_craftsmanship_text = "Nos maîtres artisans combinent techniques traditionnelles et technologie de pointe. Chaque véhicule est construit à la main, garantissant que chaque surface, chaque couture, chaque composant répond à nos normes exigeantes.";
export const about_vision_title = "Notre Vision";
export const about_vision_text = "Nous envisageons un avenir où performance et durabilité coexistent, où la technologie améliore l'expérience de conduite sans la diminuer, et où chaque voyage est une expression de l'art automobile.";
export const about_hero_subtitle_short = "Là où l'ingénierie de précision rencontre la vision artistique";
export const about_hero_scroll = "DÉFILER";
export const about_story_heading = "Les Débuts";
export const about_story_p1 = "Fondée en 2018, ORVANTHE est née d'une vision singulière : transcender les frontières entre l'ingénierie automobile et les beaux-arts. Ce qui a commencé comme un projet passion dans un modeste atelier a évolué en un atelier d'excellence automobile reconnu mondialement.";
export const about_story_p2 = "Notre fondateur, animé par une obsession de la perfection et un profond respect du patrimoine automobile, a rassemblé une équipe de maîtres artisans, d'ingénieurs et de designers partageant les mêmes standards intransigeants. Ensemble, ils ont inauguré une nouvelle approche de la personnalisation automobile.";
export const about_story_p3 = "Chaque création ORVANTHE naît de centaines d'heures de planification méticuleuse, de scanning 3D et de finition à la main. Nous ne modifions pas simplement les véhicules ; nous les reconstruisons au niveau moléculaire, réimaginant ce qui est possible quand l'art rencontre la précision de l'ingénierie.";
export const about_story_est = "Fondée en 2018";
export const about_story_since = "PRÉCISION DEPUIS LE PREMIER JOUR";
export const about_craft_heading = "En Chiffres";
export const about_craft_body = "Précision, dévouement et excellence mesurés";
export const about_craft_quote = "Nous ne construisons pas des voitures. Nous sculptons des rêves en carbone et acier, créant une poésie d'ingénierie qui se déplace à 320 km/h.";
export const about_craft_manifesto = "MANIFESTE ORVANTHE";
export const about_craft_stat1_label = "Heures par Build";
export const about_craft_stat1_desc = "Attention méticuleuse à chaque détail";
export const about_craft_stat2_label = "Maîtres Artisans";
export const about_craft_stat2_desc = "Des décennies d'expérience combinée";
export const about_craft_stat3_label = "Tolérance de Précision";
export const about_craft_stat3_desc = "Ingénierie au niveau microscopique";
export const about_craft_stat4_label = "Fini à la Main";
export const about_craft_stat4_desc = "Pas de raccourcis, pas de compromis";
export const about_phil_heading = "Notre Philosophie";
export const about_phil_body = "Quatre principes qui guident chaque décision, chaque design, chaque détail";
export const about_phil_p1_title = "Vision Sans Compromis";
export const about_phil_p1_desc = "Nous refusons d'accepter les limitations. Chaque projet commence par une question : et si nous pouvions faire mieux ? Cette quête incessante de perfection guide chaque décision, chaque mesure, chaque finition.";
export const about_phil_p2_title = "Artisanat de Maître";
export const about_phil_p2_desc = "À l'ère de l'automatisation, nous défendons la touche humaine. Nos maîtres artisans passent des années à perfectionner leurs compétences, garantissant que chaque surface, chaque couture, chaque détail reflète les plus hauts standards de qualité.";
export const about_phil_p3_title = "Innovation Sans Compromis";
export const about_phil_p3_desc = "Nous adoptons la technologie de pointe — scanning 3D, ingénierie en fibre de carbone, aérodynamique avancée — mais jamais au détriment de l'âme. La technologie sert l'art, pas l'inverse.";
export const about_phil_p4_title = "Partenariat Client";
export const about_phil_p4_desc = "Chaque création ORVANTHE est une collaboration. Nous écoutons, conseillons, affinons. Votre vision devient notre mission, et ensemble nous créons quelque chose qui transcende les attentes.";
export const about_vision_heading = "Regarder vers l'Avenir";
export const about_vision_p1 = "L'avenir de ORVANTHE ne concerne pas le volume — il s'agit d'impact. Nous ne compromettrons jamais nos standards pour augmenter la production. Au lieu de cela, nous investissons dans des matériaux de nouvelle génération, une aérodynamique avancée et des pratiques d'ingénierie durables.";
export const about_vision_p2 = "Notre vision s'étend au-delà des builds individuels. Nous créons un héritage d'innovation, formons la prochaine génération de maîtres artisans et repoussons les limites du possible quand l'art et l'ingénierie convergent.";
export const about_vision_p3 = "Chaque véhicule ORVANTHE est une déclaration : que l'excellence ne peut être précipitée, que la beauté exige de la patience, et que le vrai luxe se mesure non pas au prix, mais dans la quête de la perfection.";
export const about_vision_sustain_title = "Innovation Durable";
export const about_vision_sustain_desc = "Fabrication neutre en carbone d'ici 2026";
export const about_vision_academy_title = "Académie des Artisans";
export const about_vision_academy_desc = "Former la prochaine génération d'artisans";
export const about_vision_materials_title = "Matériaux du Futur";
export const about_vision_materials_desc = "Pionniers des composites de qualité aérospatiale";
export const about_vision_statement = "Ce n'est pas du style. C'est une reconstruction.";

export const back_to_top = "Retour en haut";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'RÉALISATIONS',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
  contact: {
    hero: {
      eyebrow: 'Nous contacter',
      title: 'Contact',
      subtitle: 'Contactez-nous pour discuter de votre vision, planifier une visite du studio ou vous renseigner sur nos services.'
    },
    info: {
      title: 'Informations du Studio',
      address: {
        label: 'Adresse',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Varsovie, Pologne'
      },
      email: {
        label: 'Email',
      },
      phone: {
        label: 'Téléphone',
      },
      hours: {
        label: 'Horaires du Studio',
        value: 'Lundi – Vendredi : 9h00 – 18h00',
        subvalue: 'Samedi : Sur rendez-vous uniquement'
      },
      social: 'Suivez-nous'
    },
    visit: {
      title: 'Planifier une visite du studio',
      description: 'Découvrez ORVANTHE en personne. Visitez nos installations, rencontrez notre équipe et explorez notre bibliothèque de matériaux et nos réalisations.',
      benefit1: 'Consultation privée avec notre équipe de design',
      benefit2: 'Sélection pratique des matériaux et finitions',
      benefit3: 'Voir les projets en cours',
      cta: 'Réserver votre visite',
      form: {
        title: 'Réserver votre visite du studio',
        subtitle: 'Sélectionnez votre date et heure préférées. Nous confirmerons la disponibilité sous 24 heures.',
        name: 'Nom complet',
        email: 'Adresse email',
        phone: 'Numéro de téléphone',
        date: 'Date préférée',
        time: 'Heure préférée',
        visitors: 'Nombre de visiteurs',
        selectTime: 'Sélectionner l\'heure',
        notes: 'Notes supplémentaires',
        notesPlaceholder: 'Des intérêts ou questions particuliers ?',
        submit: 'Confirmer la réservation',
        submitting: 'Envoi en cours...',
        validation: 'Veuillez remplir tous les champs obligatoires.',
        success: {
          title: 'Visite planifiée',
          message: 'Votre visite du studio a été confirmée. Nous vous enverrons un email de confirmation sous peu.'
        }
      }
    },
    form: {
      title: 'Envoyez-nous un message',
      subtitle: 'Nous répondons généralement sous 24 heures.',
      name: 'Nom complet',
      namePlaceholder: 'Jean Dupont',
      email: 'Adresse email',
      emailPlaceholder: 'jean@exemple.fr',
      phone: 'Numéro de téléphone',
      phonePlaceholder: '+33 1 23 45 67 89',
      subject: 'Sujet',
      subjectPlaceholder: 'Sélectionner un sujet',
      subjects: {
        general: 'Demande générale',
        carbon: 'Division Carbon',
        atelier: 'Atelier Intérieur',
        performance: 'Ligne Performance',
        build: 'Demande de projet personnalisé',
        partnership: 'Opportunité de partenariat'
      },
      message: 'Message',
      messagePlaceholder: 'Parlez-nous de votre projet ou de votre demande...',
      characters: 'caractères',
      submit: 'Envoyer le message',
      sending: 'Envoi en cours...',
      validation: 'Veuillez remplir tous les champs obligatoires.',
      maxLength: 'Le message ne peut pas dépasser 500 caractères.',
      success: {
        title: 'Message envoyé',
        message: 'Merci de nous avoir contactés. Nous avons reçu votre message.',
        response: 'Notre équipe répondra sous 24 heures.'
      }
    },
    map: {
      title: 'Trouvez notre studio',
      subtitle: 'Situé au cœur de Varsovie',
      location: 'Emplacement du studio'
    },
    faq: {
      title: 'Questions fréquemment posées',
      subtitle: 'Réponses rapides aux questions courantes',
      q1: {
        question: 'Quel est le délai typique pour un projet personnalisé ?',
        answer: 'La plupart des projets prennent 8 à 16 semaines de la consultation initiale à la livraison, selon la complexité et la disponibilité des matériaux. Des services express sont disponibles pour certains forfaits.'
      },
      q2: {
        question: 'Expédiez-vous à l\'international ?',
        answer: 'Oui, nous expédions dans le monde entier. Tous les composants en carbone sont soigneusement emballés et assurés. Un support d\'installation peut être organisé via notre réseau de partenaires.'
      },
      q3: {
        question: 'Puis-je visiter le studio sans rendez-vous ?',
        answer: 'Nous recommandons de planifier une visite à l\'avance pour garantir la disponibilité de notre équipe et vous offrir une visite et une consultation complètes.'
      },
      q4: {
        question: 'Quels modes de paiement acceptez-vous ?',
        answer: 'Nous acceptons les virements bancaires, les cartes de crédit et les cryptomonnaies. Un acompte de 50% est requis pour commencer les travaux, le solde étant dû à l\'achèvement.'
      },
      q5: {
        question: 'Proposez-vous des services d\'installation ?',
        answer: 'Oui, l\'installation professionnelle est disponible dans notre studio ou via notre réseau de partenaires certifiés en Europe et au-delà.'
      },
      q6: {
        question: 'Quelle garantie offrez-vous ?',
        answer: 'Tous les produits ORVANTHE sont couverts par une garantie de 2 ans contre les défauts de fabrication. Les composants en carbone incluent une garantie structurelle à vie.'
      },
      more: 'Vous avez encore des questions ?',
      email: 'Envoyez-nous un email directement'
    }
  }
};
